import React, { useEffect } from "react"
import { useQuery } from '@tanstack/react-query';
import { URLS } from "../config/urls"
import { getPacks } from "../services"
import "../styles/components/VacationPackagesList.scss"
import PackageMod from "../components/PackageMod"
import LoadingMod from "../components/LoadingMod"

const VacationPackagesList = () => {

  let background = {
    background: `url(https://www.surfandyogacostarica.com/assets/yoga_retreat.jpg) no-repeat center center`,
    backgroundSize: "cover"
  }

  const { isLoading, data, refetch, isError } = useQuery({
    queryKey: ['vacation_packages'],
    queryFn: async () => {
      const data = await getPacks()
      return data;
    },
  }
  );

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <article className="packages">
      <h2>CHECK OUR VACATION PACKAGES</h2>
      {isLoading ?
        <LoadingMod />
        : isError ?
          <p>Error</p>
          :
          <div className="grid">
            {(data.hasOwnProperty("packs") && data.packs.length > 0) && data.packs.map(pack => {
              return <PackageMod key={pack.id} item={pack} />
            })}
            {1===4 &&
            <div className="package" style={background}>
              <a href={"https://www.raeyaretreats.com/"} target="_blank">
                <h2>22-28 April 2024 RAEYA RETREAT, Malpais CR</h2>
                <p>A health and fitness retreat designed by women for women to bring vitality back into your life! <br /> <br />Use code “BELIEVE” for family discount</p>
                <hr />
                <p className="price"><del><em>Private</em><em>Room</em></del> <strong>3200</strong></p>
                <p className="price"><del><em>Shared</em><em>Room</em></del> <strong>2300</strong></p>
              </a>
            </div>
            }
          </div>
      }

    </article>
  )
}

export default VacationPackagesList
